/* global Excel, Office, console, document, localStorage, Date, window */

Office.onReady(() => {
  document.getElementById("sideload-msg").style.display = "none";
  document.getElementById("app-body").style.display = "flex";

  const input = document.getElementById("apiKeyInput");
  const button = document.getElementById("saveApiKeyButton");

  if (input) {
    input.value = localStorage.getItem("donkey_api_key") || "";
  }

  if (button && input) {
    button.addEventListener("click", () => {
      localStorage.setItem("donkey_api_key", input.value.trim());
      console.log("API key saved");
    });
  }

});

export async function run() {
  try {
    await Excel.run(async (context) => {
      context.workbook.worksheets.getActiveWorksheet().calculate();
      await context.sync();
      console.log("Alle FINVIA-Funktionen wurden neu berechnet.");
    });
  } catch (error) {
    console.error(error);
  }
}
